import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Cookie } from 'lucide-react';
import { Link } from 'react-router-dom';
import { captureAttribution } from '../lib/attribution';
import { startVisits } from '../lib/visits';
import { loadTrackingConfig, maybeStart, hasAnyTracker, getConsent, setConsent, clearConsent, track } from '../lib/tracking';

/**
 * Carrega a configuração de pixels, pede consentimento (LGPD) e dispara o PageView a cada troca de página.
 * Não aparece nada para o visitante quando nenhum pixel está configurado.
 */
const TrackingProvider = () => {
  const { pathname } = useLocation();
  const [config, setConfig] = useState(null);
  const [consent, setConsentState] = useState(getConsent());

  useEffect(() => {
    captureAttribution();
    startVisits();
    loadTrackingConfig().then((c) => { setConfig(c); maybeStart(c); });
    const reopen = () => { clearConsent(); setConsentState(null); };
    window.addEventListener('pp:cookie-prefs', reopen);
    return () => window.removeEventListener('pp:cookie-prefs', reopen);
  }, []);

  // PageView em cada página pública (o painel admin não é rastreado)
  useEffect(() => {
    if (pathname.startsWith('/admin')) return;
    track('page_view');
  }, [pathname]);

  const answer = (v) => {
    setConsent(v);
    setConsentState(v);
    if (v === 'granted') maybeStart(config);
  };

  const needsAsk = config && hasAnyTracker(config) && config.require_consent !== false && !consent;
  if (!needsAsk || pathname.startsWith('/admin')) return null;

  return (
    <div role="dialog" aria-live="polite" aria-label="Aviso de cookies" className="fixed inset-x-3 bottom-3 md:left-auto md:right-6 md:bottom-6 md:max-w-md z-[90] rounded-2xl bg-[#0f0f10] text-white shadow-2xl border border-white/10 p-3.5 md:p-5 pp-consent">
      <div className="flex items-start gap-3">
        <Cookie className="hidden md:block w-5 h-5 mt-0.5 text-[#2FE596] shrink-0" />
        <div className="text-xs md:text-sm leading-snug md:leading-relaxed">
          <p className="hidden md:block font-semibold">Sua privacidade importa</p>
          <p className="md:mt-1 text-white/70">
            Usamos cookies e pixels para medir visitas e mostrar ofertas mais relevantes. Você escolhe. Saiba mais na{' '}
            <Link to="/politicas" className="underline hover:text-white">Política de Privacidade</Link>.
          </p>
          <div className="mt-2.5 md:mt-4 flex gap-2">
            <button onClick={() => answer('granted')} className="flex-1 pp-btn-gradient rounded-full px-4 py-1.5 md:py-2 text-xs md:text-sm font-semibold">Aceitar</button>
            <button onClick={() => answer('denied')} className="flex-1 rounded-full px-4 py-1.5 md:py-2 text-xs md:text-sm font-semibold bg-white/10 hover:bg-white/15">Recusar</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrackingProvider;
